import { AccountColumnDef } from '@/models'

/**
 * Single source of truth for the columns of the Accounts listing.
 * Adding a column = add one entry here; removing = delete its entry.
 * Saved views that reference a column no longer listed here are ignored
 * gracefully (see orderedVisibleColumns / the view-apply logic in Accounts.vue).
 */

export const ACCOUNT_COLUMNS: AccountColumnDef[] = [
  { key: 'accountId', labelKey: 'accounts_view.columns.account_id', group: 'identity', sortable: true, defaultVisible: true, sticky: true },
  { key: 'firstName', labelKey: 'accounts_view.columns.first_name', group: 'identity', sortable: true, defaultVisible: true },
  { key: 'lastName', labelKey: 'accounts_view.columns.last_name', group: 'identity', sortable: true, defaultVisible: true },
  { key: 'country', labelKey: 'accounts_view.columns.country', group: 'classification', sortable: true, defaultVisible: true },
  { key: 'businessUnit', labelKey: 'accounts_view.columns.business_unit', group: 'classification', sortable: true, defaultVisible: false },
  { key: 'company', labelKey: 'accounts_view.columns.company', group: 'classification', sortable: true, defaultVisible: true },
  { key: 'editorialStatus', labelKey: 'accounts_view.columns.editorial_status', group: 'classification', sortable: true, defaultVisible: true, cellClass: 'text-center' },
  { key: 'active', labelKey: 'accounts_view.columns.active', group: 'classification', sortable: true, defaultVisible: true, cellClass: 'text-center' }
]

export function defaultVisibleColumnKeys(): string[] {
  return ACCOUNT_COLUMNS.filter(c => c.defaultVisible).map(c => c.key)
}

/**
 * Returns the registry columns whose key is in `visibleKeys`, in registry order.
 * Keys not present in the registry (e.g. a column removed after a view was saved)
 * are simply dropped.
 */
export function orderedVisibleColumns(visibleKeys: string[]): AccountColumnDef[] {
  const visible = new Set(visibleKeys)
  return ACCOUNT_COLUMNS.filter(c => visible.has(c.key))
}
